module.exports = __webpack_public_path__ + "img/regSupp-1.c69e710e.jpg";